import { Nav, NavItem } from 'react-bootstrap';
import styled from 'styled-components';

export const CenterGridWrapper = styled.div`
    width: 100%;
    height: 66vh;

    .action-menu {
        overflow: visible;
        //border-bottom: none;
        // line-height: 33px;
        //border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        /* width: 100%; */
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        overflow-y: scroll;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row > .ag-cell {
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 30px;
        border-width: 0px 0px 0px 1px;
        border-style: solid;
        border-color: #ccc;
    }

    .list-cell-first {
        border-bottom: none;
        text-align: center;
        line-height: 30px;
        //border-right: 1px solid #ccc;
        border-width: 0px 0px 0px 0px;
        border-style: solid;
        border-color: #ccc;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-right: 1px solid white;
        border-top: 1px solid white;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .list-group-header-left {
        border-left: 1px solid white;
        border-right: 1px solid white;
    }

    .list-group-header-not-left {
        border-right: 1px solid white;
    }

    .list-header-no-group {
        border-top: 1px solid white;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    @media (max-width: 1919px) {
        font-size: 12px;
    }
`;

export const AdminGridWrapper = styled.div`
    width: 100%;
    height: 64vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus{
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row > .ag-cell {
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 26px;
        border-color: #ccc;
    }

    .list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;


interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    fontSize?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    // & > .acc-tabs > li {
    //     height: 48px;
    // }

    // & > .acc-tabs > li > a {
    //     font-size: 14px;
    //     font-weight: 500;
    //     background-color: #337ab7;
    //     color: white;
    //     // width: 160px;
    //     text-align: center;
    //     // line-height: 15px;
    //     padding: 5px 15px;
    //     height: 100%;
    //     display: flex;
    //     justify-content: center;
    //     align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
    //     min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    // }

    // & > .acc-tabs > li.active > a {
    //     color: #555;
    //     background-color: #fff;
    // }

    & > div > .sq-pills > li > a {
        padding: 5px 7px;
    }

    & > div > .sq-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 2px;
        color: #ccc;
        // min-height: 72px;
    }

    & > div > .sq-pills > li.li-divider {
        height: 50px;
        display: flex;
        align-items: center;
    }

    & > div > .sq-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

interface INavItemProps {
    minTabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    display: flex !important;
    align-items: center;
    text-align: center;

    & > a {
        // border-radius: 8px !important;
        // text-align: center;
        // border: 1px solid #337ab7;
        // min-height: 72px;
    }

    & > a > span.badge {
        font-size: 10px;
    }

    & > a > span.type-count {
        font-size: 12px;
    }
`;

export const SwapQualityIssueWrapper = styled.div`
    padding-top: 10px;
    
    .help-block {
        font-size: 12px;
    }

    .current-image {
        border: 2px solid darkblue;
        padding: 5px;
        border-radius: 4px;
        text-align: center;
        margin-bottom: 5px;
        margin-right: 5px;
    }

    .current-image.delete-on-save {
        background-color: red;
    }

    // .current-image.delete-on-save:after {
    //     content: "This will be deleted on next save";
    //     color: white;
    // }

    .current-image.delete-on-save > img {
        opacity: 0.5;
    }
`;